<template>
    <div class="project-detail-page box" style="margin-bottom:0;">
        <div class="box-header">
            <i class="fa fa-th-large"></i><h3 class="box-title" v-if="info.projectName">{{info.projectName}} - 详情</h3>
            <div class="box-tools">
                <el-button icon="fa fa-reply" style="margin-right:10px;" size="small" class="pull-right" type="primary" @click="goBack" round> 返回</el-button>
            </div>
        </div>
        <!-- 标准方案 -->
        <div class="box-body" v-if="info.type === 'standard'" >
            <el-table class="list-table" :data="reportList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
                <el-table-column label="序号" width="50">
                    <template slot-scope="scope">
                        <span>{{page.pageSize * (page.pageNo - 1) + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="trueName" label="姓名" width="120"></el-table-column>
                <el-table-column prop="age" label="年龄" width="80"></el-table-column>
                <el-table-column prop="unit" label="公司"></el-table-column>
                <el-table-column prop="department" label="部门"></el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <span :style="'color:' + (scope.row.statue === 1 ? 'rgb(78, 194, 58);' : 'rgb(109, 141, 230);')">{{scope.row.statue === 1 ? '进行中' : '已结束'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="duration" label="时长" width="200"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" style="margin-right:4px;"  @click="editUser(scope.row)">修改</el-button>
                        <a class='load_btn' style="margin-right:4px;color:#409eff;" v-if="scope.row.statue == 2" :href="'/api/evaluate/report/pdf/' + scope.row.id + '/' + info.id" target="_blank">查看</a>
                        <el-button type="text" style="color:#f56c6c"  @click="deleteUser(scope.row, scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <page-bar v-model="page" @change="getStandardReport" @sizeChange="changeSize"></page-bar>
        </div>
        <!-- 个人方案 -->
        <div class="box-body" v-if="info.type === 'person'">
            <el-table v-if="!nowPaper.id" class="list-table" :data="paperList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
                <el-table-column label="序号" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="试卷标题"></el-table-column>
                <el-table-column prop="subtitle" label="标签"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" @click.prevent="lookPersonReport(scope.row)" size="small">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div v-else>
                <el-table class="list-table" :data="reportList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
                    <el-table-column label="序号" width="50">
                        <template slot-scope="scope">
                            <span>{{page.pageSize * (page.pageNo - 1) + scope.$index + 1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="trueName" label="姓名" width="120"></el-table-column>
                    <el-table-column prop="unit" label="公司"></el-table-column>
                    <el-table-column prop="department" label="部门"></el-table-column>
                    <el-table-column label="状态" width="100">
                        <template slot-scope="scope">
                            <span :style="'color:' + (scope.row.statue === 1 ? 'rgb(78, 194, 58);' : 'rgb(109, 141, 230);')">{{scope.row.statue === 1 ? '进行中' : '已结束'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="duration" label="时长" width="200"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <a class='load_btn' v-if="scope.row.statue == 2 && nowPaper.flag" :href="'/api/wx/' + nowPaper.flag + '/report/' + scope.row.id" target="_blank" style="color:#409eff;">下载</a>
                            <a class='load_btn' v-if="scope.row.statue == 2 && !nowPaper.flag" :href="'/api/wx/dispatch/' + scope.row.id + '/' + nowPaper.id" target="_blank" style="color:#409eff;">预览</a>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <page-bar v-model="page" @change="getPersonReport" @sizeChange="changeSize"></page-bar>
            </div>
        </div>
        <el-dialog
          title="修改信息"
          :visible.sync="edit_dialog"
          width="40%"
          :before-close="() => { this.edit_dialog = false; this.now_edit = {} }">
            <el-form :model="now_edit" ref="edit-form" :rules="edit_rules" label-width="100">
                <el-form-item prop="trueName" label="姓名">
                    <el-input v-model="now_edit.trueName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item prop="age" label="年龄">
                    <el-input v-model="now_edit.age" placeholder="请输入年龄"></el-input>
                </el-form-item>
                <el-form-item prop="unit" label="公司">
                    <el-input v-model="now_edit.unit" placeholder="请输入公司名称"></el-input>
                </el-form-item>
                <el-form-item prop="department" label="部门">
                    <el-input v-model="now_edit.department" placeholder="请输入部门名称"></el-input>
                </el-form-item>
            </el-form>
            <div style="display: flex;justify-content: flex-end">
                <el-button @click="() => { this.edit_dialog = false; this.now_edit = {} }">取 消</el-button>
                <el-button type="primary" @click="saveUser">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getSchemeByProjectId, editUser, getStandardReport, getPersonScheme, getPersonReport, deleteUser } from "@/api/manage/company";

import PageBar from '@/components/PageBar.vue'
import {deepClone, timeDuration} from "../../utils";
export default {
    name: 'project-detail-page',
    data () {
        return {
            info: {},
            reportList: [],
            page: { pageSize: 20, pageNo: 1, total: 0 },
            nowPaper: {},
            paperList: [], //个人方案下的试卷列表
            routerInfo: {},

            now_edit: {},
            edit_rules: {
                trueName: [ {required:true,message:'请输入真实姓名',trigger:'blur'} ],
                unit: [ {required:true,message:'请输入公司名称',trigger:'blur'} ],
                department: [ {required:true,message:'请输入部门名称',trigger:'blur'} ],
                age: [ {required:true,message:'请输入年龄',trigger:'blur'} ]
            },
            edit_dialog: false
        }
    },
    components:{ PageBar },
    created () {
        this.routerInfo = this.$route.query
        this.getDetail()
    },
    methods: {
        saveUser () {
            let info = deepClone(this.now_edit)
            this.$refs['edit-form'].validate(valid => {
                if (valid) {
                    info.id = this.now_edit.id
                    editUser(info).then(res => {
                        if (res.data.code === 200) {
                            this.now_edit = {}
                            this.edit_dialog = false
                            this.$message.success('修改成功')
                            this.getStandardReport(1)
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => {
                        throw new Error(err)
                    })
                }
            })
        },
        editUser (data) {
            this.now_edit = deepClone(data)
            this.edit_dialog = true
        },
        deleteUser (data, index) {
            this.$confirm('是否确定删除该人员', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteUser(data.id).then(res => {
                    if(res.data.code === 200){
                        this.reportList.splice(index, 1)
                        this.$message.success('删除成功')
                    }else{
                        this.$message.error(res.data.message)
                    }
                }).catch(err => {
                    this.loading = false
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        lookPersonReport (data) {
            this.nowPaper = data
            this.getPersonReport(1)
        },
        changeSize (size) {
            this.page.pageSize = size
            if (this.info.type === 'standard') {
                this.getStandardReport(1)
            } else if (this.info.type === 'person'){
                this.getPersonReport(1)
            }
        },
        getPersonReport (page) {
          let paperId = this.nowPaper.id
          let projectId = this.routerInfo.projectId
          let query = { pageSize: this.page.pageSize,pageNo: page}
          getPersonReport(projectId,paperId,query).then(res => {
              if (res.data.code === 200) {
                  let info = res.data.result || {}
                  let list = info.records || []
                  let data = res.data.result
                  this.$set(this.page,'total',data.total)
                  this.$set(this.page,'pageNo',data.pageNo)
                  this.$set(this.page,'pageSize',data.pageSize)
                  list.map(item => {
                      if (item.statue === 2) {
                          item.duration = timeDuration(item.start * 1000, item.end * 1000)
                      }
                  })
                  this.reportList = list
              } else {
                  this.$message.error(res.data.message)
              }
          }).catch(err => {
              throw new Error(err)
          })
        },
        getDetail () {
            getSchemeByProjectId(this.$route.query.projectId).then(res => {
                if (res.data.code === 200) {
                    this.info = res.data.result || {}
                    if (this.info.type === 'standard') {
                        this.getStandardReport(1)
                    } else if (this.info.type === 'person') {
                        this.getPersonScheme()
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                throw new Error(err)
            })
        },
        getPersonScheme () {
            getPersonScheme(this.routerInfo.projectId).then(res => {
                if (res.data.code === 200) {
                    let list = res.data.result || []
                    this.paperList = list
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                throw new Error(err)
            })
        },
        getStandardReport (page) {
            let query = {
                pageSize: this.page.pageSize,
                pageNo: page,
            }
            getStandardReport(this.routerInfo.projectId,query).then(res => {
                if (res.data.code === 200) {
                    let info = res.data.result || {}
                    let list = info.records || []
                    this.page = {
                        pageSize: info.pageSize,
                        pageNo: info.pageNo,
                        total: info.total
                    }
                    list.map(item => {
                        if (item.statue === 2) {
                            item.duration = timeDuration(item.startTime * 1000, item.endTime * 1000)
                        }
                    })
                    this.reportList = list
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                throw new Error(err)
            })
        },
        goBack () {
            if (this.nowPaper.id) {
                this.nowPaper = {}
                this.getPersonScheme()
            } else {
                this.$router.go(-1)
            }
        }
    }
}
</script>

<style lang="scss">
.project-detail-page{

}
</style>
